import appApi from '../../../api/app-api';
import { toast } from 'react-toastify';
import { LecturesSideBarFilterDatamodel } from '../side-bar/lectures-side-bar-filter-datamodel';
import { ReportBranchType } from '../../../api/types/reports/report-branch.type';
import { ReportProgram } from '../../../api/types/reports/report-abstract-program.type';
import { ReportCourseType } from '../../../api/types/reports/report-abstract-course.type';
import {
  LectureStatus,
  LectureStatusType,
} from '../../../api/types/programs/course/lectures/lecture-status.type';
import { ReportUserType } from '../../../api/types/reports/report-user.type';
import { displayErrorText } from '../../../api/errors/api-error-codes';

export interface ReportClassType {
  classId: number;
  className: string;
}

interface LecturerWorkingHours extends ReportUserType {
  workingStartTime: Date;
  workingEndTime: Date;
}

export interface LecturesResType
  extends ReportBranchType,
    ReportProgram,
    ReportCourseType,
    ReportClassType {
  lecturers: LecturerWorkingHours[];
  startTime: Date;
  endTime: Date;
  lectureStatus: LectureStatus;
  studentNumberInCourse: number;
  studentAttendance: number;
  lectureSubject: string;
  lectureBreakMinutes: number | null;
}

export const getLecturesDataOperation = async (
  filters: LecturesSideBarFilterDatamodel,
  offset: number,
  limit: number,
  setLoading: (loading: boolean) => void,
  setData: (data: LecturesResType[]) => any,
  setTotal: (total: number) => any,
) => {
  try {
    setLoading(true);

    const res = await appApi.getLectures({
      ...filters,
      offset,
      limit,
    });
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    const paginationResponse = res.data.body;

    // Ensure we have valid pagination response
    if (!paginationResponse) {
      setData([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    if (!Array.isArray(paginationResponse.data)) {
      console.error('Invalid data in pagination response:', paginationResponse);
      setData([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    setData(paginationResponse.data);
    const totalCount = paginationResponse.total ?? 0;
    setTotal(totalCount);
    setLoading(false);
  } catch (error) {
    console.error(
      `getLecturesDataOperation is failed with the filterData: ${JSON.stringify(filters)} and the error: ${error}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    throw error;
  }
};
